import { AfterContentInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Location } from '@angular/common';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LicenseService } from 'src/app/core/services/license.service';
import { PackageType } from 'src/app/core/models/package-type.model';
import { User } from 'src/app/core/models/user.model';
import * as utils from 'src/app/shared/helpers/utils';

@Component({
  selector: 'hbo-package-type-actions',
  templateUrl: './package-type-actions.component.html',
  styleUrls: ['./package-type-actions.component.scss']
})
export class PackageTypeActionsComponent implements OnInit, AfterContentInit {

  @Input() packageType!: PackageType;
  @Output() reload: EventEmitter<any> = new EventEmitter();

  action = 'create';

  user: User = utils?.localStorageGetItem('user');
  confirmationModal: any;

  packageTypeForm = this.formBuilder.nonNullable.group({
    id: [''],
    name: ['', Validators.required],
    private: ['', Validators.required],
    testDays: ['', Validators.required]
  });

  apps = ['LensProgressive (LP)', 'Coach Progressive (CP)', 'LensOffice (LO)', 'Coach Office (CO)', 'Fit (IF) ', 'Made4U (IM)', '360 Depict (DE)', 'Lens Single Vision (LS)'];
  appIds: number[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private licenseService: LicenseService,
    private location: Location
  ) { }

  ngOnInit() {
    if (!this.packageType) {
      this.packageType = { id: 0 } as PackageType;
    } else {
      this.action = 'edit';
      this.packageTypeForm.get('id')?.disable();
      this.packageTypeForm.get('name')?.disable();
      this.packageTypeForm.get('private')?.disable();
      this.packageTypeForm.get('testDays')?.disable();
    }
  }

  ngAfterContentInit() {
    if (this.packageType && this.packageType.id !== 0) {
      this.packageTypeForm.patchValue({
        id: this.packageType.id?.toString(),
        name: this.packageType.name?.toString(),
        private: this.packageType.private?.toString(),
        testDays: this.packageType.testDays?.toString(),
      });

      this.appIds.push(...this.packageType.appPackages.map(app => app.appId));
    }
  }

  save() {
    this.packageTypeForm.markAllAsTouched();
    if (this.packageTypeForm.valid) {
      if (this.action === 'create') {
        this.licenseService.insertPackageType({ ...this.packageTypeForm.value, appIds: this.appIds  } as unknown as PackageType).subscribe(res => {
          this.router.navigate(['licenses/package-types']);
        });
      } else if (this.action === 'edit') {
        this.licenseService.updatePackageType({ ...this.packageTypeForm.value, appIds: this.appIds  } as unknown as PackageType).subscribe(res => {
          this.reload.emit();
        });
      }
    }
  }

  delete() {
    this.licenseService.destroyPackageType(this.packageType.id).subscribe(res => {
      this.reload.emit();
    });
  }

  cancel() {
    if (this.action === 'create') {
      this.location.back();
    } else {
      this.reload.emit();
    }
  }

  toggleApp(appId: number) {
    if (!this.appIds.includes(appId)) {
      this.appIds.push(appId);
    } else {
      this.appIds = this.appIds.filter(id => id !== appId);
    }
  }

}
